import { BarsOutlined } from '@ant-design/icons'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderTaskCommon } from '../common'

export const ProviderTaskClient: ProviderClient = {
  key: ProviderTaskCommon.key,
  description: {
    label: 'Task',
    icon: <BarsOutlined />,
    triggers: [
      {
        key: 'UpdatedTaskStatus',
        label: 'Task status updated',
        input: [],
        output: [],
      },
      {
        key: 'UpdatedTaskAssignee',
        label: 'Task assignee updated',
        input: [],
        output: [],
      },
      {
        key: 'NewComment',
        label: 'New comment',
        input: [],
        output: [],
      },
      {
        key: 'NewTask',
        label: 'Task created',
        input: [],
        output: [],
      },
      {
        key: 'DueTask',
        label: 'Task due',
        input: [],
        output: [],
      },
    ],
    actions: [],
  },
}
